export interface IFieldsData {
    account_type: string;
    label_account_id: string;
    account_detail_type: Array<IAccountDetailType>;
    bank_name_required: boolean;
    banks_list?: Array<string>;
    identification: boolean;
    placeholder_identification: string;
    label_identification: string;
}

export interface IAccountDetailType {
    id: number;
    detail: string;
}

export const accounts_data_of_type: Array<IFieldsData> = [
    {
        account_type: 'nequi_account',
        label_account_id: 'Número de teléfono',
        account_detail_type: [],
        bank_name_required: false,
        identification: true,
        placeholder_identification: 'Por ejemplo: 1093323124',
        label_identification: 'Cédula n°'
    },
    {
        account_type: 'argentina_bank_account',
        label_account_id: 'CBU/CVU/Alias',
        account_detail_type: [],
        bank_name_required: false,
        identification: true,
        placeholder_identification: 'Por ejemplo: 20346641872 (sin guiones)',
        label_identification: 'CUIT/CUIL del titular'
    },
    {
        account_type: 'mexico_bank_account',
        label_account_id: 'CLABE',
        account_detail_type: [],
        bank_name_required: false,
        identification: false,
        placeholder_identification: '',
        label_identification: ''
    },
    {
        account_type: 'venezuela_bank_account',
        label_account_id: 'Cuenta n°',
        account_detail_type: [],
        bank_name_required: false,
        identification: true,
        placeholder_identification: 'Por ejemplo: 8292411',
        label_identification: 'Pasaporte o Cédula n°'
    },
    {
        account_type: 'pago_movil_account',
        label_account_id: 'Cuenta n°',
        account_detail_type: [],
        bank_name_required: false,
        identification: true,
        placeholder_identification: 'Por ejemplo: 0102-8292411',
        label_identification: 'Pasaporte o Cédula n°'
    },
    {
        account_type: 'colombia_bank_account',
        label_account_id: 'Cuenta n°',
        account_detail_type: [
            {
                id: 1,
                detail: 'Caja de Ahorros'
            },
            {
                id: 2,
                detail: 'Cuenta Corriente'
            }
        ],
        bank_name_required: true,
        banks_list: [
            'Banco de Bogotá',
            'Bancolombia',
            'Citibank',
            'BBVA Colombia',
            'Davivienda',
            'Banco Santander',
            'Banagrario',
            'Banco Occidente',
            'Banco Popular'
        ],
        identification: true,
        placeholder_identification: 'Por ejemplo: 1093323124',
        label_identification: 'Cédula n°'
    },
    {
        account_type: 'europe_bank_account',
        label_account_id: 'IBAN',
        account_detail_type: [],
        bank_name_required: false,
        identification: false,
        placeholder_identification: '',
        label_identification: ''
    },
    {
        account_type: 'bolivia_account',
        label_account_id: 'Cuenta n°',
        account_detail_type: [
            {
                id: 1,
                detail: 'Caja de Ahorros'
            },
            {
                id: 2,
                detail: 'Cuenta Corriente'
            }
        ],
        bank_name_required: false,
        identification: true,
        placeholder_identification: 'Por ejemplo: CAE-9823456789123456789012',
        label_identification: 'Identificación n°'
    },
    {
        account_type: 'email_or_phone',
        label_account_id: 'Email/Teléfono',
        account_detail_type: [],
        bank_name_required: false,
        identification: false,
        placeholder_identification: '',
        label_identification: ''
    }
];
